import React, { useState } from 'react';
import { Calendar, BarChart3 } from 'lucide-react';
import AgendaTab from '../components/planning/AgendaTab';
import GanttTab from '../components/planning/GanttTab';

type TabType = 'agenda' | 'gantt';

const Planning: React.FC = () => {
  const [activeTab, setActiveTab] = useState<TabType>('agenda');

  const tabs = [
    {
      id: 'agenda' as TabType,
      name: 'Agenda',
      icon: Calendar,
      description: 'Schedule meetings and invite team members'
    },
    {
      id: 'gantt' as TabType,
      name: 'Gantt Chart',
      icon: BarChart3,
      description: 'Project timeline and dependencies'
    }
  ];

  return (
    <div className="p-6">
      {/* Header */}
      <div className="mb-8">
        <h1 className="text-3xl font-bold text-gray-900">Planning</h1>
        <p className="mt-2 text-gray-600">
          Manage meeting schedules and project timelines
        </p>
      </div>

      {/* Tab Navigation */}
      <div className="border-b border-gray-200 mb-6">
        <nav className="-mb-px flex space-x-8">
          {tabs.map((tab) => {
            const Icon = tab.icon;
            const isActive = activeTab === tab.id;
            
            return (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                className={`group inline-flex items-center py-4 px-1 border-b-2 font-medium text-sm ${
                  isActive
                    ? 'border-blue-500 text-blue-600'
                    : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                }`}
              >
                <Icon
                  className={`-ml-0.5 mr-2 h-5 w-5 ${
                    isActive ? 'text-blue-500' : 'text-gray-400 group-hover:text-gray-500'
                  }`}
                />
                <span>{tab.name}</span>
              </button>
            );
          })}
        </nav>
      </div>

      {/* Tab Content */}
      <div className="mt-6">
        {activeTab === 'agenda' && <AgendaTab />}
        {activeTab === 'gantt' && <GanttTab />}
      </div>
    </div>
  );
};

export default Planning;




